module.exports = __webpack_public_path__ + "img/base_activites_vtt.0f892eb3.svg";